/** @jsx jsx */

// TODO if we change the location of the burger exitCode
// then the fauxFocus needs to be updated

import {
  Fragment as _,
  useState,
  useEffect,
  useRef,
  useMemo,
  useLayoutEffect,
  ReactElement,
} from 'react';
import { css, jsx } from '@emotion/core';
import { createPortal } from 'react-dom';
import { Menu } from '../TopicMenu/Menu';
import { getButtonFocus } from 'styles/variables';
import { useHeader } from 'services/useHeader';
import { getScrollBarWidth } from 'services/getScrollBarWidth';

const width = 24;

interface IMenuContainerProps {
  id: string;
  rootSelector: string;
}

const MenuContainer = (props: IMenuContainerProps) => {
  const { id, rootSelector } = props;
  const [root, setRoot] = useState<HTMLElement | null>(null);
  const [fauxFocus, setFauxFocus] = useState<boolean>(false);
  const [menu, setMenu] = useState<boolean>(false);

  const header = useHeader();

  const currentHeaderProps = header[header.props.headerStyle].props;

  const {
    topicMenu,
    headerBackgroundColor,
    headerTextColor,
  } = currentHeaderProps;

  const hiddenButton = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    const root = document.querySelector(rootSelector) as HTMLElement;

    if (root) {
      setRoot(root);
    }

    return () => {
      setRoot(null);
    };
  }, []);

  let fauxFocusColor: any = getButtonFocus(headerTextColor);

  fauxFocusColor = fauxFocusColor?.split(',')[1]?.trim();

  return (
    <_>
      <button
        type="button"
        ref={hiddenButton}
        id={`hidden-button-menu-${id}`}
        css={css({
          outline: 'none',
          border: 'none',
          //
          position: 'fixed',

          right: 33,
          top: 70,
          width: 18,
          height: 1,
          //
          background: 'transparent',
          overflow: 'hidden',

          '@media (max-width: 480px)': {
            right: 18,
          },
        })}
        onFocus={() => {
          setFauxFocus(true);

          const section = hiddenButton.current?.closest(
            'section'
          ) as HTMLElement;
        }}
        onBlur={() => {
          setFauxFocus(false);

          // return;
          // give focus to the ACTUAL content container in the section
          const section = hiddenButton.current?.closest(
            'section'
          ) as HTMLElement;

          if (section) {
            const contentContainer = section.querySelector(
              `#i${id}-content-container`
            ) as HTMLElement;
          }
        }}
        onClick={() => {
          setMenu(menu => !menu);
        }}
        aria-label="open menu"
        // NOTE: removed as potentially the cause of JAWS jumping into form mode. . .
        // aria-haspopup="true"
      />

      {
        (root
          ? createPortal(
              <div
                css={css({
                  position: 'fixed',
                  right: 0,
                  top: 0,
                  zIndex: 2147483647,
                })}
              >
                {fauxFocus && (
                  <div
                    css={css({
                      position: 'fixed',
                      right: 30 - getScrollBarWidth(),
                      top: 25,
                      width: width,
                      height: width - 4,

                      boxShadow: `0 0 0 2px ${headerBackgroundColor}, ${fauxFocusColor}`,

                      '@media (max-width: 480px)': {
                        right: 15,
                        top: 14.5,
                      },
                    })}
                  />
                )}
                <div
                  style={{
                    position: 'fixed',
                    right: -30 - getScrollBarWidth(),
                  }}
                >
                  <Menu
                    menu={menu}
                    close={() => {
                      hiddenButton.current?.focus();
                      setMenu(false);
                    }}
                  />
                </div>
              </div>,
              root
            )
          : null) as ReactElement
      }
    </_>
  );
};

export { MenuContainer };
